<template>
  <b-card no-body>
    <b-card-header class="d-flex align-items-center justify-content-between">
      <b-card-title>
        {{ dataItem.title }}
      </b-card-title>
      <b-card-sub-title>
        Proje Kodu: {{ dataItem.pcode }}
      </b-card-sub-title>
    </b-card-header>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      :busy="dataLoading"
      :empty-text="emptyText"
      :show-empty="!!emptyText"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle" />
          <strong class="ml-2">Yükleniyor...</strong>
        </div>
      </template>
      <template #cell(file_size)="data">
        <div>{{ data.item.file_size | fileSizeFromKB }}</div>
      </template>
      <template #cell(username)="data">
        {{ data.item.username }}
        <div v-if="data.item.created">
          <small class="text-primary">
            <feather-icon icon="SaveIcon" />
            {{ moment(data.item.created).format('DD.MM.YYYY HH:mm:ss') }}
          </small>
        </div>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <download-file
            file-component="projects"
            :file-id="Number(data.item.id)"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-if="dataCounts > perPage"
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BTable, BPagination, BCardFooter, BSpinner, BCardTitle, BCardHeader,
  BCardSubTitle,
} from 'bootstrap-vue'
import DownloadFile from '@/layouts/components/DownloadFile.vue'

const tableName = 'project_files'
export default {
  name: 'ProjectSecretFiles',
  components: {
    BCardSubTitle,
    BCardHeader,
    BCardTitle,
    DownloadFile,
    BCard,
    BTable,
    BPagination,
    BCardFooter,
    BSpinner,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Dosya',
        },
        {
          key: 'file_size',
          label: 'BOYUT',
          thClass: 'width-100 text-nowrap text-right',
          tdClass: 'width-100 text-nowrap text-right',
        },
        {
          key: 'document_groups',
          label: 'Dosya Grubu',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'username',
          label: 'Ekleyen',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.file_size AS file_size`,
          `${tableName}.is_secret AS is_secret`,
          `${tableName}.created AS created`,
          'document_groups.title AS document_groups',
          'users.name AS username',
        ],
        where: {
          'project_files.is_secret': 1,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
    dataList() {
      return this.$store.getters['projectFiles/dataListSecret']
    },
    dataCounts() {
      return this.$store.getters['projectFiles/dataCountsSecret']
    },
    saveData() {
      return this.$store.getters['projectFiles/dataSaveStatus']
    },
    dataLoading() {
      return this.$store.getters['projectFiles/loading']
    },
    emptyText() {
      if (this.dataLoading === true) {
        return 'Lütfen bekleyiniz...'
      }
      if (this.dataList.length === 0) {
        return 'İçerik bulunamadı.'
      }
      return null
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.dataQuery.where['project_files.id_projects'] = this.$route.params.id
      this.$store.dispatch('projectFiles/getSecretDataList', this.dataQuery)
    },
  },
}
</script>
